"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MULTIPLE_CHOICE_MAP () {
        return MULTIPLE_CHOICE_MAP;
    },
    get MULTIPLE_SELECT_MAP () {
        return MULTIPLE_SELECT_MAP;
    },
    get MULTI_SELECT_AGGREGATIONS () {
        return MULTI_SELECT_AGGREGATIONS;
    },
    get MultiSelectAggregation () {
        return MultiSelectAggregation;
    },
    get NUMERIC_RANGE () {
        return NUMERIC_RANGE;
    },
    get PASSTHROUGH () {
        return PASSTHROUGH;
    },
    get PASS_FAIL () {
        return PASS_FAIL;
    },
    get QuestionRubricSchema () {
        return QuestionRubricSchema;
    },
    get RATING_SCALE_MAP () {
        return RATING_SCALE_MAP;
    },
    get SCORING_STRATEGY_TYPES () {
        return SCORING_STRATEGY_TYPES;
    },
    get SKIP_BEHAVIORS () {
        return SKIP_BEHAVIORS;
    },
    get ScoringRubricModel () {
        return ScoringRubricModel;
    },
    get ScoringStrategySchema () {
        return ScoringStrategySchema;
    },
    get ScoringStrategyType () {
        return ScoringStrategyType;
    },
    get SkipBehavior () {
        return SkipBehavior;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const RATING_SCALE_MAP = "rating_scale_map";
const MULTIPLE_CHOICE_MAP = "multiple_choice_map";
const MULTIPLE_SELECT_MAP = "multiple_select_map";
const NUMERIC_RANGE = "numeric_range";
const PASS_FAIL = "pass_fail";
const PASSTHROUGH = "passthrough";
const SCORING_STRATEGY_TYPES = [
    RATING_SCALE_MAP,
    MULTIPLE_CHOICE_MAP,
    MULTIPLE_SELECT_MAP,
    NUMERIC_RANGE,
    PASS_FAIL,
    PASSTHROUGH
];
const ScoringStrategyType = _zod.z.enum(SCORING_STRATEGY_TYPES);
const RatingScaleMapConfig = _zod.z.object({
    type: _zod.z.literal(RATING_SCALE_MAP),
    /** Maps rating-scale option value → normalized score (0-100) */ value_score_map: _zod.z.record(_zod.z.string(), _zod.z.number())
});
const MultipleChoiceMapConfig = _zod.z.object({
    type: _zod.z.literal(MULTIPLE_CHOICE_MAP),
    /** Maps choice index (as string) → score (0-100) */ choice_score_map: _zod.z.record(_zod.z.string(), _zod.z.number())
});
const MULTI_SELECT_AGGREGATIONS = [
    "sum",
    "average",
    "max"
];
const MultiSelectAggregation = _zod.z.enum(MULTI_SELECT_AGGREGATIONS);
const MultipleSelectMapConfig = _zod.z.object({
    type: _zod.z.literal(MULTIPLE_SELECT_MAP),
    /** Maps choice index (as string) → score (0-100) */ choice_score_map: _zod.z.record(_zod.z.string(), _zod.z.number()),
    /** How to combine scores from multiple selected choices */ aggregation: MultiSelectAggregation
});
const NumericRangeConfig = _zod.z.object({
    type: _zod.z.literal(NUMERIC_RANGE)
});
const PassFailConfig = _zod.z.object({
    type: _zod.z.literal(PASS_FAIL),
    /** answer >= threshold → 100, else 0 */ threshold: _zod.z.number()
});
const PassthroughConfig = _zod.z.object({
    type: _zod.z.literal(PASSTHROUGH)
});
const ScoringStrategySchema = _zod.z.discriminatedUnion("type", [
    RatingScaleMapConfig,
    MultipleChoiceMapConfig,
    MultipleSelectMapConfig,
    NumericRangeConfig,
    PassFailConfig,
    PassthroughConfig
]);
const SKIP_BEHAVIORS = [
    "score_zero",
    "exclude"
];
const SkipBehavior = _zod.z.enum(SKIP_BEHAVIORS);
const QuestionRubricSchema = _zod.z.object({
    question_id: _zod.z.instanceof(_bson.ObjectId),
    scoring_strategy: ScoringStrategySchema,
    /** Weight as percentage 0-100. All weights in a rubric should sum to 100. */ weight: _zod.z.number().min(0).max(100),
    skip_behavior: SkipBehavior.optional(),
    /** Explanation of scoring rationale — useful for LLM-generated rubrics and human review */ note: _zod.z.string().optional()
});
const ScoringRubricModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    form_id: _zod.z.instanceof(_bson.ObjectId),
    question_rubrics: _zod.z.array(QuestionRubricSchema).refine((rubrics)=>{
        if (rubrics.length === 0) return true;
        const sum = rubrics.reduce((acc, r)=>acc + r.weight, 0);
        return Math.abs(sum - 100) < 0.01;
    }, {
        message: "Question rubric weights must sum to 100"
    }),
    created_at: _utilsisomorphic.transformDate,
    updated_at: _utilsisomorphic.transformDate,
    created_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    updated_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    deleted_at: _utilsisomorphic.transformDate.optional(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).optional()
});
